/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import type { ICellRendererParams } from 'ag-grid-community'
import type { PlayerFamilyRow } from '@sportninja/common/features/profile/player/playerDetails'
import StatusTag from 'src/components/ts-components/StatusTag'

/**
 * Family table Status cell: the invitation status chip, plus an Admin chip
 * when the member has admin access — the same chips as the family list.
 */
const FamilyStatusCell = <TRow extends PlayerFamilyRow>({
  data,
}: ICellRendererParams<TRow>) => {
  if (!data) {
    return null
  }

  return (
    <div css={cellStyle}>
      <StatusTag
        tone={data.status === 'accepted' ? 'success' : 'warning'}
        label={data.status}
        dot
      />
      {data.isAdmin ? <StatusTag tone='info' label='Admin' /> : null}
    </div>
  )
}

export default FamilyStatusCell

// ---- styled ----
const cellStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
`
